// extracted by mini-css-extract-plugin
export default {"promotion":"Promotion__promotion--3WU","button":"Promotion__button--NcA","details":"Promotion__details--2qD","terms":"Promotion__terms--2jB"};